export default "Once Upon A Time åbnede i 2024.";